module.exports = __webpack_public_path__ + "assets/img/GOAL.44647d2a.png";